import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProjectLoadingProvider } from './contexts/ProjectLoadingContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import JoinCrewPage from './pages/JoinCrewPage'; // 🎬 项目组邀请页面
import InviteClaimPage from './pages/InviteClaimPage'; // 🎫 放号领码页面
import DashboardPage from './DashboardPage';
import EditorPage from './EditorPage';
import ErrorBoundary from './components/ErrorBoundary';
import useDocumentTitle from './hooks/useDocumentTitle';
import useViewportHeightVar from './hooks/useViewportHeightVar';
import { useTheme } from './hooks/useTheme';

function App() {
  // 📌 浏览器标签页标题跟软件名(登录品牌 appName)联动，各站按各自数据库配置显示
  useDocumentTitle();
  // 📱 把真实可视高度写进 --app-vh，供根容器锁定高度(iPad Chrome 键盘不收缩视口的兜底)
  useViewportHeightVar();
  // 🎨 首帧应用主题（深色默认/浅色），把 data-theme 打到 <html>，CSS 变量令牌接管配色
  useTheme();
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ProjectLoadingProvider>
          <BrowserRouter>
            <Routes>
              {/* 登录页面（无需认证） */}
              <Route path="/login" element={<LoginPage />} />

              {/* 🎬 项目组邀请页面 */}
              <Route path="/join/:token" element={<JoinCrewPage />} />
              {/* 🎫 放号领码页面 */}
              <Route path="/invite/:token" element={<InviteClaimPage />} />
              {/* 受保护的页面（需要登录） */}
              <Route path="/" element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } />
              <Route path="/editor/:projectId" element={
                <ProtectedRoute>
                  <EditorPage />
                </ProtectedRoute>
              } />

              {/* 未匹配路由重定向 */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ProjectLoadingProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
